import { render, staticRenderFns } from "./callBack.vue?vue&type=template&id=5a60ae74&scoped=true"
import script from "./callBack.vue?vue&type=script&lang=js"
export * from "./callBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a60ae74",
  null
  
)

export default component.exports